import * as eff from 'redux-saga/effects';
import createActionCreators from 'redux-resource-action-creators';

import {
  actionTypes,
} from '../actions';
import {
  throwError,
  getEntityType,
} from './helpers';
import {
  getExerciseNumber,
} from '../utils';
import api from '../api';

export const normalizedExercises = exercises => exercises.reduce(
  (acc, { exercise_properties: properties, ...rest }) => ({
    workoutExercises: [
      ...acc.workoutExercises,
      {
        ...rest,
        // add to every { letter: '', number: '' } from order_name
        ...getExerciseNumber(rest),
      },
    ],
    exerciseProperties: [
      ...acc.exerciseProperties,
      ...properties,
    ],
  }), {
    workoutExercises: [],
    exerciseProperties: [],
  },
);

export default function* workoutFlow(reportChannel) {
  function* getFull({ id, resourceType, addtionalType }) {
    const actions = createActionCreators('read', {
      resourceType: addtionalType || resourceType,
      requestKey: addtionalType ? 'getFullAdditionalWorkout' : 'getFullWorkout',
      resources: [id],
    });

    yield eff.put(actions.pending({}));

    try {
      const {
        exercises,
        assignees,
        group_assignments: groupAssignments,
        ...workout
      } = yield eff.call(
        api.getEntity,
        {
          id,
          type: getEntityType(resourceType),
        },
      );

      const customLists: any = {};
      const includedResources: any = {};

      if (!exercises.length && resourceType === 'personalWorkouts') {
        yield eff.put(
          reportChannel,
          {
            messageType: 'notify',
            message: {
              type: 'warn',
              key: 'workoutExercises.warn.empty',
            },
          },
        );
      }

      if (exercises !== undefined) {
        const {
          workoutExercises,
          exerciseProperties,
        } = normalizedExercises(exercises);

        customLists.workoutExercises = `workout_${id}`;
        customLists.exerciseProperties = `workout_${id}`;
        includedResources.workoutExercises = workoutExercises;
        includedResources.exerciseProperties = exerciseProperties;
      }

      if (assignees !== undefined) {
        customLists.assignees = `workout_${id}`;
        includedResources.assignees = assignees;
      }

      if (groupAssignments !== undefined) {
        customLists.groupAssignments = `workout_${id}`;
        includedResources.groupAssignments = groupAssignments;
      }

      yield eff.put(actions.succeeded({
        resources: [workout],
        includedResources,
        customLists,
      }));
    } catch (e) {
      yield eff.put(actions.failed({
        resources: [],
      }));
      yield eff.call(throwError, e);
    }
  }

  yield eff.takeEvery(actionTypes.REQUEST_FULL_WORKOUT, getFull);
}
